import { Injectable } from '@angular/core';
import { Plan } from './plan';
import { Customer } from './../customers/customers';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';


@Injectable({
  providedIn: 'root'
})

export class PlanService {

  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<Plan[]>([]);

  gridObject$: Observable<Plan[]> = this.subject.asObservable();
  currentPlan: Observable<Plan>;
  planArray = [];


  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {

    const http$ = this.gridHttp();
    // this.isLoading = true;

    http$.pipe(
      map(res => res),
      tap(() => {
        this.isLoading = false;
      })
    ).subscribe(
      res => {
        this.subject.next(res.Plans);
        this.planArray = res.Plans;

      }
    );

  }

  getInitial() {
      return this.gridObject$.pipe(
      map(plans => plans)
    );
  }

  getOnePlan(id): Observable<any> {

    return this.http.get(this.baseURL + '/rhAPI/plans/getOne/' + id).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
        } else {
          this.messager.openSnackBar(message, 'Editing...', 'successAlert');
        }
      })
    );
  }


  // add a plan
  addPlan(changes): Observable<any> {
    // get reference to contact array
    const plans = this.subject.getValue();
    return this.http.post(this.baseURL + '/rhAPI/plans/getAdd', changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
          //this.subject.next(plans);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    );
  }

  addOneFrontend(changes): void {
    const plans = this.subject.getValue();
    const newPlanList = plans.slice(0);
    newPlanList.unshift(changes);
    this.subject.next(newPlanList);
  }


  deleteOnePlan(planId: number): void {
    const plans = this.subject.getValue();
    const planIndex = plans.findIndex(plan => plan.plan_id === planId);

    const newPlans = plans.slice(0);

    newPlans.splice(planIndex, 1);
    this.subject.next(newPlans);


  }

  saveEditedPlan(planId: number, changes): Observable<any> {

    const plans = this.subject.getValue();
    const planIndex = plans.findIndex(plan => plan.plan_id === planId);
    const newPlanList = plans.slice(0);

    newPlanList[planIndex] = {
      ...plans[planIndex],
      ...changes
    };

    this.subject.next(newPlanList);
    return this.http.post(this.baseURL + '/rhAPI/plans/saveOne/' + planId, changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
          this.subject.next(plans);
        } else {
          this.messager.openSnackBar(message, 'Saved!', 'successAlert');
        }
      })
    );

  }

// return all plans
  gridHttp(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/plans/getAll', {observe: 'body'});
  }

  createDriveFolder(object): Observable<any> {

    return this.http.post(this.baseURL + '/rhAPI/driveCreateFolderPlans', object, {observe: 'body'});

  }


  updateIndexOf(index, link): void {
    const plans = this.subject.getValue();
      
    plans[index].drivelink = link;
  
    this.subject.next(plans);


  } 

  // plan.service.ts

  getTotalVolume(plan: any): number {
    const hvac1 = parseFloat(plan.hvac_1_area) * parseFloat(plan.hvac1_ceil_ht) || 0;
    const hvac2 = parseFloat(plan.hvac_2_area) * parseFloat(plan.hvac2_ceil_ht) || 0;
    const hvac3 = parseFloat(plan.hvac_3_area) * parseFloat(plan.hvac3_ceil_ht) || 0;
    const hvac4 = parseFloat(plan.hvac_4_area) * parseFloat(plan.hvac4_ceil_ht) || 0;
    const addvol = parseFloat(plan.addvol) || 0;
  
    return hvac1 + hvac2 + hvac3 + hvac4 + addvol;
  }
  getFilteredPlans(bedFilter: string, areaFilter: string, volumeFilter: string, noteFilter: string, namefilter: string): void {
    const plans = this.planArray;
  
    let bedroomValues: number[] = [];
    let areaValues: number[] = [];
    let volumeValues: number[] = [];
    let noteValues: number[] = [];
  
    const parseInput = (input: string): number[] => {
      input = input?.trim();
      if (!input) return [];
  
      if (input.includes('-')) {
        const [start, end] = input.split('-').map(n => parseInt(n.trim(), 10));
        if (!isNaN(start) && !isNaN(end)) {
          return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        }
      } else if (input.includes(',')) {
        return input.split(',').map(n => parseInt(n.trim(), 10)).filter(n => !isNaN(n));
      } else {
        const num = parseInt(input, 10);
        return !isNaN(num) ? [num] : [];
      }
  
      return [];
    };
  
    // Parse each input
    bedroomValues = parseInput(bedFilter);
    areaValues = parseInput(areaFilter);
    volumeValues = parseInput(volumeFilter);
    const noteKeywords = noteFilter
    ? noteFilter
        .toLowerCase()
        .split(',')
        .map(k => k.trim())
        .filter(k => k)
    : [];
    const nameKeywords = namefilter
    ? namefilter.toLowerCase().split('&').map(k => k.trim()).filter(k => k)
    : [];
  
    // Filtering logic
    const filtered = plans.filter(plan => {
      const totalVolume = this.getTotalVolume(plan);
      const planNotes = (plan.plan_notes || '').toLowerCase();
      const planName = (plan.plan_name || '').toLowerCase();
      const bedMatch = bedroomValues.length === 0 || bedroomValues.includes(Number(plan.bedrooms));
      const areaMatch = areaValues.length === 0 || areaValues.includes(Number(plan.totalarea));
      const volumeMatch = volumeValues.length === 0 || volumeValues.includes(Math.round(totalVolume));
      const noteMatch =
      noteKeywords.length === 0 ||
      noteKeywords.every(keyword => planNotes.includes(keyword));
      const nameMatch = nameKeywords.length === 0 || nameKeywords.every(keyword => planName.includes(keyword));
      return bedMatch && areaMatch && volumeMatch && noteMatch && nameMatch;
    });
  
    this.subject.next(filtered);
  }
  

  
  resetFilter() {
    this.subject.next(this.planArray);
  }

}
